import React from 'react';
import { PracticeAddress } from './PracticeAddress';
import { Typography } from "src/latest/src/components";

interface Section {
  questions: {
    choices: string[];
  }[];
}

interface Props {
  section: Section;
  title?: string;
}

export const TherapistPracticeAddress: React.FC<Props> = ({
  section,
  title,
}) => {
  return (
    <>
      {title && (
        <Typography
          variant="size-14"
          weight="bold"
          color="color-28"
          className="therapist-profile__title mb-3"
        >
          {title}
        </Typography>
      )}
      {section &&
        section.questions?.map((question, index) => (
          <>
            {question && (
              <PracticeAddress
                key={index}
                choices={question?.choices}
                isPracticeAddress={false}
              />
            )}
          </>
        ))}
    </>
  );
};
